import _defineProperty from "babel-runtime/helpers/defineProperty";
import _Promise from "babel-runtime/core-js/promise";
import dict from "../../../../../tools/dict";
import sysConfig from "../../../../../config/sysConfig";
var getOriginalData = function getOriginalData(options) {
  if (options.data && options.data.length) {
    return _Promise.resolve(options.data);
  } else if (options.dict) {
    return dict.getDictData(options.dict).then(function (dictData) {
      return _Promise.resolve(dictData && dictData[options.dict] || []);
    });
  } else if (options.req && _.isPlainObject(options.req) && !_.isEmpty(options.req)) {
    return sysConfig.$syscfg.K_Request(options.req.service, _.omit(options.req, "service")).then(function (data) {
      return data.Data;
    });
  }
};

export default {
  name: "kui-combobox",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      disabled: false,
      loading: false,
      value: [],
      isPassValidate: true,
      originalData: [],
      data: []
    };
  },
  computed: {
    titleName: function titleName() {
      return this.options.title ? this.options.title + ":" : "";
    },
    valueField: function valueField() {
      return this.options.dict ? "DICT_ITEM" : this.options.valueField || "dict_val";
    },
    textField: function textField() {
      return this.options.dict ? "DICT_ITEM,DICT_ITEM_NAME" : this.options.textField || "dict_val,dict_des";
    },
    separator: function separator() {
      return this.options.separator || ",";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return getOriginalData(this.options).then(function (originalData) {
      _this.originalData = originalData;
      _this.loadData(_this.originalData);
      _this.combobox(_this.options);
      _this.options.disabled ? _this.setDisabled() : _this.setEnabled();
    });
  },

  methods: {
    combobox: function combobox(opts) {
      var _this2 = this;

      if (_.isString(opts)) {
        if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
        } else {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1]);
        }
      } else {
        _.assign(this.options, opts);
        _.each(this.options, function (v, k) {
          if (!_.isFunction(v) && k == "value") {
            _this2.setValue(v);
          }
        });
      }
    },
    change: function change() {
      var _this3 = this;

      var value = this.options.multiple ? this.value.join(this.separator) : this.value;

      this.clear();
      return _Promise.all([_.isFunction(this.options.onChange) ? this.options.onChange(value) : true]).then(function (res) {
        if (res[0] === false) {
          return;
        }
        _this3.setValue(value);
        _this3.validate();
      });
    },
    remoteMethod: function remoteMethod(v) {
      this.options.remoteMethod && this.options.remoteMethod(v);
    },
    hideTips: function hideTips() {
      this.isPassValidate = true;
      this.$refs.validator.hideTips();
    },
    validate: function validate() {
      return this.isPassValidate = this.$refs.validator.validate(this.value);
    },

    getValue: function getValue() {
      return this.options.multiple ? this.value.join(this.separator) : this.value;
    },
    setValue: function setValue(value) {
      this.value = this.options.multiple ? value && value.split(this.separator) || [] : value;
    },
    setEnabled: function setEnabled() {
      this.disabled = false;
    },
    setDisabled: function setDisabled() {
      this.disabled = true;
    },
    loadData: function loadData(data) {
      var _this4 = this;

      return _Promise.all([_.isFunction(this.options.loadFilter) ? this.options.loadFilter(data) : data]).then(function (res) {
        _this4.data = _.map(res[0], function (obj) {
          return {
            dict_val: obj[_this4.valueField],
            dict_des: _.map(_this4.textField.split(","), function (val) {
              return obj[val];
            }).join("-")
          };
        });
      });
    },
    getData: function getData() {
      return _defineProperty({}, this.options.field, this.getValue());
    },
    clear: function clear() {
      this.value = [];
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/combobox/src/combobox.js
// module id = 1481
// module chunks = 2